import { AnimalCard } from "backend/src/common/types/ExtensionCard";
import { getGeneratedAnimalName, Locale } from "backend/src/common/i18n";

export const getAnimalDefaultName = (
  card: AnimalCard,
  locale: Locale,
): string => {
  return (
    card.meta.name ||
    card.meta.generatedName ||
    getGeneratedAnimalName(locale, "animal")
  );
};
